










































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import Loading from "../general/Loading.vue";

export default Vue.extend({
  name: "Login",
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      loginName: "",
      loginPassword: "",
      isLoading: false,
    };
  },
  methods: {
    async submit() {
      this.isLoading = true;

      let restClient = new RestClient(this.loginName, this.loginPassword);

      try {
        let users = await restClient.getUsers();
        let user = users.find((user) => user.email.toLowerCase() == this.loginName.toLowerCase());
        if (user !== undefined) {
          this.$emit("loggingin", user.ID, this.loginName, this.loginPassword, user.permissionRank, user);
        }

        this.isLoading = false;
      } catch (e) {
        alert(e.message);

        this.isLoading = false;
      }
    },
  },
});
